import { http } from 'interfaces'
import { type ExecutivePosition } from 'services/person/us/edit/executiveRolesService'

export interface ExecutivePositionSearchResults {
  data: ExecutivePosition[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}

export async function searchExecutivePositions (
  params: any
): Promise<ExecutivePositionSearchResults> {
  const response = await http.get('/api/v1/us/executives/positions/', { params })
  return response.data
}
